module.exports = __webpack_public_path__ + "img/game_1_2.9212b752.png";